const settings = {
  // Page meta
  pageTitle: 'الإعدادات',
  pageSubtitle: 'إدارة البيانات الرئيسية والإعدادات على مستوى المدرسة',
  // Tabs
  classMaster: 'قائمة الفصول',
  rolesMaster: 'قائمة الأدوار',
  sections: 'الأقسام',
  general: 'عام',
  calendarSettings: 'إعدادات التقويم',
  // General tab
  generalSettingsTitle: 'الإعدادات العامة',
  generalSettingsDescription: 'الملف التعريفي للمدرسة وإعدادات العام الدراسي والتفضيلات العامة الأخرى ستكون متاحة هنا. حالياً، استخدم علامات تبويب <strong>قائمة الفصول</strong> و <strong>قائمة الأدوار</strong> و <strong>الأقسام</strong> لإدارة البيانات الرئيسية.',
  goToClassMaster: 'الذهاب إلى قائمة الفصول',
  // Class Master
  classMasterDescription: 'تحديد وإدارة جميع أسماء الفصول المستخدمة في المدرسة. التعديلات مرنة — كل مدرسة تستخدم اصطلاحات تسمية خاصة بها.',
  noClassesDefined: 'لم يتم تحديد أي فصول بعد. أضف أول فصل للبدء.',
  // Roles Master
  rolesMasterDescription: 'إدارة أدوار الموظفين والمسميات الوظيفية. أضف أدواراً مخصصة لتتناسب مع الهيكل التنظيمي لمدرستك.',
  noRolesDefined: 'لم يتم تحديد أي أدوار بعد. أضف أول دور للبدء.',
  // Sections
  sectionsDescription: 'إدارة أقسام الفصول مثل أ، ب، ج أو أي تسميات أقسام مخصصة تستخدمها مدرستك.',
  noSectionsDefined: 'لم يتم تحديد أي أقسام بعد. أضف أول قسم للبدء.',
  // Master list
  addButton: 'إضافة {{type}}',
  enterName: 'أدخل الاسم...',
  moveUp: 'تحريك للأعلى',
  moveDown: 'تحريك للأسفل',
  deleteConfirm: 'حذف؟',
  // Stats cards
  classesDefined: 'فصول محددة',
  rolesConfigured: 'أدوار مكونة',
  sectionsDefined: 'أقسام محددة',
  // Footer
  itemCount: '{{count}} عنصر',
  itemCountPlural: '{{count}} عناصر',
  // Breadcrumbs
  settingsBreadcrumb: 'الإعدادات',
  // Calendar Settings specific
  awarenessEventsMaster: 'قائمة فعاليات التوعية',
  holidayMaster: 'قائمة العطلات',
};

export default settings;